// DAS-3194: earnings badge on the alert cards. The server builds the text
// (utils/alert_earnings_badge.py, same words as the morning advice): a report due
// within 14 days, or one that came out within the last 7. Information only.

const TONE_COLOR = {
  miss: 'error',
  beat: 'success',
  inline: 'default',
  upcoming: 'info',
};

export default function earningsBadge(alert) {
  const b = alert && alert.earnings_badge;
  if (!b || !b.label) return null;
  return { text: b.label, tooltip: b.tooltip || b.label, color: TONE_COLOR[b.tone] || 'default' };
}
